module.exports = __webpack_public_path__ + "src/assets/images/current_location.svg?db1c54abf6f2a8fd56548fed59283998";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/current_location.svg
// module id = 902
// module chunks = 0